export enum Scene {
  game = "game",
  menu = "menu",
  win = "win"
}